/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const status940EnumSchema = z
	.enum(["created", "paid", "cancelled", "created_request_for_refund", "waiting_for_refund", "failed_refund", "refunded"])
	.describe(
		"* `created` - Создан\n* `paid` - Оплачен\n* `cancelled` - Отменен\n* `created_request_for_refund` - Создан запрос на возврат средств\n* `waiting_for_refund` - Ожидает возврата средств\n* `failed_refund` - Ошибка возврата средств\n* `refunded` - Средства возвращены",
	);
